import { DAY_TRACK_PX, LEAD_PX, TODAY_TRACK_PX } from '@aj/ui';

/**
 * How many days of history fit in the space we have.
 *
 * Two weeks is the floor: fewer than that and the chart stops showing a
 * pattern, which is the only reason it exists. Six weeks is the ceiling —
 * past that the squares are decoration, and a year wants a heatmap instead.
 *
 * The answer is always a whole number of weeks, which does two things: every
 * column sits under the same weekday as the window changes, and the count
 * only moves in 7-day steps, so dragging a window edge doesn't make the chart
 * twitch a column at a time.
 */
export const MIN_DAYS = 14;
export const MAX_DAYS = 42;

export function fitDays(width: number): number {
  // Today's track is wider than a past day's, and the name block never scrolls.
  const forPastDays = width - LEAD_PX - TODAY_TRACK_PX;
  const past = Math.floor(forPastDays / DAY_TRACK_PX);
  const weeks = Math.floor((past + 1) / 7);
  return Math.min(MAX_DAYS, Math.max(MIN_DAYS, weeks * 7));
}
